<template>
  <div class="flex items-center" >
    <StreakDay v-if="today >= startedOn" :day="today" isToday="true" :done="isDone(today)" @addDay="$emit('addDay', today)" @removeDay="$emit('removeDay', today)"/>

    <StreakDay v-if="yesterday >= startedOn" :day="yesterday" :done="isDone(yesterday)" @addDay="$emit('addDay', yesterday)" @removeDay="$emit('removeDay', yesterday)"/>

    <StreakDay v-if="dayBeforeYesterday >= startedOn" :day="dayBeforeYesterday" :done="isDone(dayBeforeYesterday)" @addDay="$emit('addDay', dayBeforeYesterday)" @removeDay="$emit('removeDay', dayBeforeYesterday)"/>

    <StreakDay v-if="daysAgo3 >= startedOn" :day="daysAgo3" :done="isDone(daysAgo3)" @addDay="$emit('addDay', daysAgo3)" @removeDay="$emit('removeDay', daysAgo3)"/>
    <StreakDay v-if="daysAgo4 >= startedOn" :day="daysAgo4" :done="isDone(daysAgo4)" @addDay="$emit('addDay', daysAgo4)" @removeDay="$emit('removeDay', daysAgo4)"/>
    <StreakDay v-if="daysAgo5 >= startedOn" :day="daysAgo5" :done="isDone(daysAgo5)" @addDay="$emit('addDay', daysAgo5)" @removeDay="$emit('removeDay', daysAgo5)"/>
    <StreakDay v-if="daysAgo6 >= startedOn" :day="daysAgo6" :done="isDone(daysAgo6)" @addDay="$emit('addDay', daysAgo6)" @removeDay="$emit('removeDay', daysAgo6)"/>
    <!-- <span class="text-sm">last 7 days</span> -->
  </div>
</template>

<script>
import _ from 'lodash'
import {addDays, midnight, formatyyymmdd} from '@/helpers/date'
import StreakDay from './StreakDay'

export default {
  components: {
    StreakDay
  },
  props: ['formatedDatesDone', 'startedOn'],
  data () {
    return {
      innerModel: [],
    }
  },
  watch: {
    'value': {
      immediate: true,
      handler (value) {
        this.innerModel = value
      }
    },
    'innerModel': {
      immediate: false,
      handler (value) {
        this.$emit('input', value)
      }
    },
  },
  computed: {
    today () {
      return midnight()
    },
    yesterday () {
      return addDays(this.today, -1)
    },
    dayBeforeYesterday () {
      return addDays(this.today, -2)
    },
    daysAgo3 () {
      return addDays(this.today, -3)
    },
    daysAgo4 () {
      return addDays(this.today, -4)
    },
    daysAgo5 () {
      return addDays(this.today, -5)
    },
    daysAgo6 () {
      return addDays(this.today, -6)
    },
    id () {
      return _.kebabCase(this.title)
    },
    checked () {
      return _.includes(this.innerModel, this.title)
    },
  },
  methods: {
    isDone (date) {
      return _.includes(this.formatedDatesDone, formatyyymmdd(date))
    }
  }
}

</script>
